import { finish, error } from '../../../modules/customers/actions/currency-validation';

import api from '../../../api';

export function request(dispatch, { customerId }) {
    api.get(`/wallets/validation/${customerId}/currency-change`).then(
        (response) => dispatch(finish(customerId, response)),
        ({ errors }) => dispatch(error(customerId, errors))
    );
}
